<template>
  <div>
    <div class="container pt-0">
      <div class="row">
        <div class="col text-center">
          <h1 class="fs-40">{{ $t("heading_moveearly") }}</h1>
        </div>
      </div>
      <div class="row">
        <div
          class="col-12"
          :class="{ 'col-lg-10 offset-lg-1': selectedTermin }"
        >
          <div class="pane">
            <div class="row">
              <div
                v-if="proposal"
                class="col-md-5 pr-lg-5 text-left border-md-right"
                :class="{
                  'col-md-6': selectedTermin,
                }"
              >
                <h2>{{ $t("actual_appointment") }}</h2>
                <termin-zusammenfassung type="actual"
                  :stornierung-anzeigen="actualTermin && actualTermin.start && selectedTermin && !kostenlosVerschieben"
                  :kostenlos-vorverlegen-anzeigen="actualTermin && actualTermin.start && kostenlosVerschieben"
                />
                <overlay ref="terminBereitsVergebenAlert">
                  <div class="text-center">
                    <div class="font-weight-bold fs-14 mb-3">
                      {{ $t("error.termin_bereits_vergeben") }}
                    </div>
                    <button
                      class="btn btn-primary"
                      @click="unselectTermin"
                    >
                      {{ $t("zur_terminwahl") }}
                      <font-awesome-icon icon="arrow-right" />
                    </button>
                  </div>
                </overlay>
                <overlay ref="errorAlert" blocking>
                  <div class="text-center">
                    <h4>{{ $t("error.api_error_headline") }}</h4>
                    <div>{{ $t("error.api_error_body") }}</div>
                  </div>
                </overlay>
                <overlay ref="absagenAlert">
                  <div style="width: 280px">
                  <div class="text-center">
                    <div class="font-weight-bold fs-14 mb-3">
                      {{ $t("frage_termin_absagen") }}
                    </div>
                    <button
                      class="btn btn-primary mr-2"
                      @click="absagen"
                    >
                      {{ $t("actions.termin_absagen") }}
                    </button>
                    <button
                      class="btn btn-outline-secondary"
                      @click="$refs.absagenAlert.hide()"
                    >
                      {{ $t("actions.cancel") }}
                    </button>
                  </div>
                  </div>
                </overlay>
              </div>
              <overlay ref="naechsterTerminAlert">
              <div class="text-center">
                <div class="font-weight-bold fs-14 mb-3" v-if="$t('error.kein_termin_in_woche')">
                  {{ $t("error.kein_termin_in_woche") }}
                </div>
                <button
                  class="btn btn-primary"
                  @click="
                    startDate = nextTermin;
                    ladeTermine();
                  "
                >
                  {{ $t("naechster_termin") }}
                  {{ nextTermin | dateShort }}
                  <font-awesome-icon icon="arrow-right" />
                </button>
              </div>
            </overlay>
            <overlay ref="keinTerminAlert">
              <div class="text-center">
                <div class="font-weight-bold fs-14 mb-3">
                  {{ $t("error.kein_termin_gefunden") }}
                </div>
              </div>
            </overlay>
              <div v-if="!selectedTermin" class="col mt-3 mt-md-0">

                <calendar
                  v-if="startDate && !selectedDay && !selectedRow"
                  @dateChanged="ladeTermine"
                  :anzahl-tage="anzahlTage"
                  vorverlegt
                />
                <!--<div
                  v-if="
                    selectedDay != null &&
                    selectedRow != null &&
                    !selectedTermin
                  "
                >
                  <terminauswahl/>
                </div>-->
              </div>
              <div
                v-if="selectedTermin"
                class="col-md-5 pl-lg-5 mt-3 mt-md-0"
                :class="{ 'col-md-6': selectedTermin }"
              >
                <div class="row">
                  <div class="col-10">
                    <h2>{{ $t("new_appointment") }}</h2>
                  </div>
                  <div class="col-2 text-right">
                    <font-awesome-icon
                      style="cursor: pointer"
                      icon="pencil-alt"
                      @click="unselectTermin"
                    />
                  </div>
                </div>
                <termin-zusammenfassung stornierung-anzeigen/>
              </div>
            </div>
          </div>

          <div v-if="selectedTermin" class="row">
            <div class="col-12 d-none d-lg-block mb-3">
              <div class="row mt-3">
                <div class="col-md-6">
                  <button
                    class="btn btn-outline-secondary"
                    @click="$store.dispatch('verschiebenAbbrechen')"
                  >
                    {{ $t("actions.verschiebung_abbrechen") }}
                  </button>
                </div>
                <div class="col-md-6 text-right">
                  <button
                    class="btn btn-primary"
                    :disabled="$store.getters.isLoading"
                    @click="book"
                  >
                    {{ kostenlosVerschieben ? $t("actions.termin_vorverschieben") : $t("actions.termin_verschieben_kostenpflichtig") }}
                  </button>
                </div>
              </div>
            </div>
            <div class="col-12 d-lg-none mb-3">
              <div class="row mt-3">
                <div class="col-12 text-right">
                  <button
                    class="btn btn-primary w-100"
                    :disabled="$store.getters.isLoading"
                    @click="book"
                  >
                    {{ kostenlosVerschieben ? $t("actions.termin_vorverschieben") : $t("actions.termin_verschieben_kostenpflichtig") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TerminZusammenfassung from "@/components/TerminZusammenfassung";
  import Calendar from "@/components/Calendar";
  //import Terminauswahl from "@/components/Terminauswahl";
  import { SET_START_DATE } from "../store/mutations.type";
  import {
    SET_BEHANDLUNG,
    SET_BEHANDLUNGSART,
    SET_SELECTED_DAY,
    SET_SELECTED_ROW,
    SET_SELECTED_TERMIN,
    SET_BEHANDLERAUSWAHL_UEBERSPRUNGEN,
  } from "../store/mutations.type";
  import { DateTime, Interval } from "luxon";
  import { Api } from "@/api/";


  export default {
    name: "VorVerschiebung",
    components: {
      TerminZusammenfassung,
      Calendar,
      //Terminauswahl,
    },
    data() {
      return {
        token: this.$route.query.moveearly,
        nextTermin: null,
      };
    },
    async created() {
      await this.$store.dispatch("loadActualTermin", [this.token]);

      if(!this.terminart.otp) {

        this.$store.commit("setPage", "rueckruf")

      } else {

        let d = DateTime.fromISO(this.proposal.start).toJSDate();
        if(d.isValid) {
          let day = d.getDay();
          let diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
          this.startDate = new Date(  d.setDate(diff));
        } else {
          this.startDate = new Date();
        }

        await this.ladeTermine();
      }
    },
    computed: {
      termine() {
        return this.$store.state.termine;
      },
      behandlung: {
        get() {
          return this.$store.state.termin.behandlung;
        },
        set(val) {
          this.behandler = null;
          this.$store.commit(`termin/${SET_BEHANDLUNG}`, val);
        },
      },
      startDate: {
        get() {
          return this.$store.state.startDate;
        },
        set(val) {
          this.$store.commit(`${SET_START_DATE}`, val);
        },
      },
      behandlungsart: {
        get() {
          return this.$store.state.termin.behandlungsart;
        },
        set(val) {
          this.$store.commit(`termin/${SET_BEHANDLUNGSART}`, val);
        },
      },
      proposal() {
        return this.$store.state.termin.actualTermin;
      },
      selectedDay: {
        get() {
          return this.$store.state.termin.selectedDay;
        },
        set(val) {
          this.$store.commit(`termin/${SET_SELECTED_DAY}`, val);
        },
      },
      selectedRow: {
        get() {
          return this.$store.state.termin.selectedRow;
        },
        set(val) {
          this.$store.commit(`termin/${SET_SELECTED_ROW}`, val);
        },
      },
      selectedTermin: {
        get() {
          return this.$store.state.termin.selectedTermin;
        },
      },
      actualTermin: {
        get() {
          return this.$store.state.termin.actualTermin;
        },
      },
      terminart() {
        return this.$store.state.termin.behandlung;
      },
      praxis() {
        if (typeof this.$store.state.termin.praxis === "string")
          return this.$store.state.praxen.find(
            (p) => p.value === this.$store.state.termin.praxis
          );
        else return this.$store.state.termin.praxis;
      },
      anzahlTage() {
        return this.isMobile ? 4 : 7;
      },
      kostenlosVerschieben() {
        return this.selectedTermin?.stornierung?.vorverlegt || false;
      },
    },
    methods: {
      absagen() {
        let lang = this.$route.query.lang || this.$route.query.lng
        let url = `${window.location.origin}${window.location.pathname}?cancel=${this.token}${lang ? '&lang='+lang : ''}`;
        window.location.href=url;
      },
      async ladeTermine() {
        if (!this.behandlung) return;
        if (this.$refs.naechsterTerminAlert)
          this.$refs.naechsterTerminAlert.hide();
        if (this.$refs.keinTerminAlert) this.$refs.keinTerminAlert.hide();
        let cnt = await this.$store.dispatch("loadTermineByTermin", [
          this.startDate,
          this.anzahlTage,
          this.actualTermin.id,
          this.praxis.value,
          this.behandler ? this.behandler.id : null,
        ]);
        if (cnt > 0) {
          // Termine gefunden, checke, ob die in der aktuellen Woche liegen, sonst zeige Hinweis
          let firstTermin = this.termine[0];
          let startDate = DateTime.fromISO(firstTermin.start);
          let duration = Interval.fromDateTimes(this.startDate, startDate);

          if (duration.count("days") > this.anzahlTage) {
            this.nextTermin = startDate.toJSDate();
            if (this.$refs.naechsterTerminAlert)
              this.$refs.naechsterTerminAlert.show();
          }
        } else if (cnt == 0) {
          // Keine Termine in den nächsten Wochen, zeige Hinweis
          if (this.$refs.keinTerminAlert) this.$refs.keinTerminAlert.show();
        }
      },
      unselectTermin() {
        if (this.$store.state.termin.behandlerauswahlUebersprungen) {
          this.$store.commit(`termin/${SET_SELECTED_DAY}`, null);
          this.$store.commit(`termin/${SET_SELECTED_ROW}`, null);
          this.$store.commit(
            `termin/${SET_BEHANDLERAUSWAHL_UEBERSPRUNGEN}`,
            false
          );
        }
        this.$store.commit(`termin/${SET_SELECTED_TERMIN}`, null);
      },
      async book() {
        let absagen = false;
        try {
          let json = {
            datum: DateTime.fromISO(this.selectedTermin.start).toFormat(
              "dd.MM.yyyy"
            ),
            start: this.selectedTermin?.start,
            schicht: this.selectedTermin?.shift?.id,
            actualTermin: this.actualTermin?.id,
            token: this.token,
            absagen: absagen,
          };

          // eslint-disable-next-line no-unused-vars
          let response = await Api.post("/book/move/", json);

          if (response.status === 409) {
            this.$refs.patientendaten.showTerminBereitsVergeben();
          } else {

            //url.insertUrlParam("token", this.token, true);
            //url.removeUrlParam("move", this.token, true);

            this.$store.commit("setPage", "termin-bestaetigt");
          }
        } catch (e) {
          if (e.response.status === 409) {
            this.$refs.patientendaten.showTerminBereitsVergeben();
          } else {
            this.$refs.errorAlert.show();
          }
        } finally {
          if (this.isMobile) {
            const el = document.getElementById(this.appId);
            if (el) {
              el.scrollIntoView({ behavior: "smooth", block: "start" });
            }
          }
        }
      },
    },
  };
</script>
